/********GAMES************/
export const GAMES_PATH = '/games';
/********REFUNDS************/
export const REFUNDS_PATH = '/refunds';
/********ALL INAPPS************/
export const INAPPS_GROUPS_PATH = '/games/:gameId';
export const INAPPS_LIST_ALL_PATH = '/games/:gameId/all-inapps';
export const NEW_INAPP_PATH = '/games/:gameId/all-inapps/new-inapp';
export const INAPP_EDITING_PATH = '/games/:gameId/all-inapps/:inappId';
/********SALES INAPPS************/
export const INAPPS_LIST_SALE_PATH = '/games/:gameId/sales-inapps';
export const NEW_SALE_PATH = '/games/:gameId/sales-inapps/new-sale';
export const SALE_INAPP_EDITING_PATH = '/games/:gameId/sales-inapps/:inappId';
/********TECHNICAL ROUTS************/
export const LOGIN_PATH = '/login';
export const CALLBACK_PATH = '/login/callback';
export const ERROR_PATH = '/page_not_found';
export const HOME_PATH = '/';
